import React from "react";
import { useState } from 'react'
import images from 'assets/images'
import {useSelector} from "react-redux";
import {selectAuth} from "../SingIn/authSlice";
import OmwaAccessModal from "../../components/OmwaAccessModal";
import Sidebar from "./Sidebar";
import NavigationMenuItem from "./NavigationMenuItem";
import {OMWA_URL} from "../../constants/constants";
import NewDashboardLink from "../../components/NewDashboardLink";

// Main Layout Component
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const {dashboard_menu_items} = useSelector(selectAuth);
    const [showOmwaAccessModal, setShowOmwaAccessModal] = useState(false);
    return (
        <div className="relative">
            {/* Mobile Menu Button */}
            {!sidebarOpen && ( // Hide button when sidebar is open
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="absolute top-4 left-4 z-50 md:hidden p-2 bg-primary text-white rounded-full shadow-lg"
                    aria-label="Open Sidebar"
                >
                    {/* Icon for the menu button */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 6h16M4 12h16m-7 6h7"
                        />
                    </svg>
                </button>
            )}

            <div id="sideBar">
                <Sidebar setDialogOpen={setShowOmwaAccessModal} navigation={dashboard_menu_items} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
                    <div className="flex flex-col flex-grow bg-primary overflow-y-hidden">
                        <div className="flex items-center justify-center flex-shrink-0 py-8">
                            <img
                                style={{ width: "176px", height: "45px" }}
                                className="h-24 w-auto"
                                src={images.logoTMW}
                                alt="Workflow"
                            />
                        </div>
                        <nav className="flex-1 space-y-1">
                            <div className="px-4 pb-2">
                                <NewDashboardLink />
                            </div>
                            {dashboard_menu_items.map((item) => (
                                <NavigationMenuItem key={item.name} item={item} setDialogOpen={setShowOmwaAccessModal} />
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
            <div className="md:pl-64 flex flex-col flex-1">
                <div>{children}</div>
            </div>
            <OmwaAccessModal
                isOpen={showOmwaAccessModal}
                onClose={() => {
                    setShowOmwaAccessModal(false);
                }}
                onFindOutMore={() => {
                    setShowOmwaAccessModal(false);
                    // Open the URL in a new tab
                    window.open(OMWA_URL, '_blank');
                }}
            />
        </div>
    );
};

export default Layout;